import { Component, OnInit, ViewChild,HostListener } from '@angular/core';
import { HelperService } from '../helper.service';
import { Http, Response,Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import {MatSnackBar} from '@angular/material';
import { NgForm } from '@angular/forms';
import { Router,ActivatedRoute, Params } from '@angular/router';
import {FormControl} from '@angular/forms';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import {CookieService} from 'angular2-cookie/core';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css']
})
export class SettingsComponent implements OnInit {
	// 	@HostListener('window:beforeunload', ['$event'])
//   unloadHandler(event: Event) {
//   localStorage.removeItem('access_token');
//   localStorage.removeItem('navigateroute');
// }
	email;
	contact;
	address;
	about;
  public Editor = ClassicEditor;
  user_permissions:any=[];
  user_token= localStorage.getItem('access_token');
  private headers: Headers = new Headers({
  'Accept': 'application/json',
  'Authorization': "Bearer "+this.user_token
});
  	constructor(private helper:HelperService,private http:Http,private snackbar: MatSnackBar,private activatedRouter:ActivatedRoute,private router:Router,private cookie:CookieService) { }

  	ngOnInit() {
      let user=this.cookie.get('user_id');
    this.http.get(this.helper.base_url+'/http/get/user/permissions',{ headers: this.headers })
    
    .subscribe(data => {
      this.user_permissions = JSON.parse(data['_body']);
     //console.log(this.user_permissions);
        
     
    });
	    this.http.get(this.helper.base_url+'http/get/settingsList',{ headers: this.headers })
	      
	      .subscribe(data => {
	        this.email = JSON.parse(data['_body']).email;
	        this.contact = JSON.parse(data['_body']).contact;
	        this.address = JSON.parse(data['_body']).address;
	        this.about = JSON.parse(data['_body']).about;
	    });
  	}

  	edit_form(updateForm: NgForm)
    {
      let body = new FormData();
      body.append('email', this.email);
      body.append('contact', this.contact);
      body.append('address', this.address);
      body.append('about', this.about);
      
      this.http.post(this.helper.base_url+'http/update/settingsUpdate', body,{ headers: this.headers })
        .subscribe((data) => 
        {
          let body = JSON.parse(data['_body']);
          
          if(body.success == 1)
          {
            this.refresh(false,body.message) ;
          }
          else
          {
            this.snackbar.open(body.message, null, {
              duration:5000,
                extraClasses:'error-snackbar',
                verticalPosition:'top'
              });
          }
        }, //For Success Response
        err => {console.error(err)} //For Error Response);
      );
    }

    refresh(val=false,msg='')
  	{
  		this.snackbar.open(msg, null, 
  		{
    		duration:5000,
      		extraClasses:'success-snackbar',
      		verticalPosition:'top'
   	 	});
  		this.router.navigateByUrl('/redirect', {skipLocationChange: true}).then(()=>
  		this.router.navigate(["settings"]));
 	}

}



// WEBPACK FOOTER //
// ./src/app/settings/settings.component.ts